<template>
  <div class="performance-card" :class="cardClasses">
    <div v-if="loading" class="performance-card__spinner">
      <i class="performance-card__spinner-icon fas fa-spinner fa-spin fa-2x fa-fw"></i>
    </div>
    <div v-else class="performance-card__inner">
      <PerformanceCardHeader :title="title" :tooltip="tooltip" />
      <div class="performance-card__container">
        <CardItemError v-if="showErrorMessage" :error="error" />
        <div v-else>
          <CardItemHeader>Percent Of Attributable Sales</CardItemHeader>
          <CardTransition>
            <CardItem :performanceTypes="performanceTypes" :metrics="attributableSalesMetrics"/>
          </CardTransition>
          <hr />
          <CardItemHeader>Percent Of Attributable Units Sold</CardItemHeader>
          <CardTransition>
            <CardItem :performanceTypes="performanceTypes" :metrics="salesMetrics"/>
          </CardTransition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PerformanceCardHeader from './PerformanceCardHeader/PerformanceCardHeader';
import CardItem from './CardItem/CardItem';
import CardItemHeader from './CardItem/CardItemHeader/CardItemHeader';
import CardItemError from './CardItem/CardItemError/CardItemError';
import CardTransition from './CardTransition';

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    tooltip: {
      type: String
    },
    tableData: {
      type: Array
    },
    shouldBlurValues: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean
    },
    error: {
      type: Boolean
    },
  },
  computed: {
    showErrorMessage() {
      return !this.loading && (this.error || !this.hasTableData)
    },
    cardClasses() {
      return {
        'performance-card--blurred': this.shouldBlurValues
      }
    },
    hasTableData() {
      return this.tableData && this.tableData.length
    },
    performanceTypes() {
      if (this.hasTableData) {
        return this.tableData.map(obj => obj.device_type || obj.app_type)
      }

      return []
    },
    attributableSalesMetrics() {
      if (this.hasTableData) {
        return this.tableData.map(obj => obj['pct_of_attributable_sales'])
      }

      return []
    },
    salesMetrics() {
      if (this.hasTableData) {
       return this.tableData.map(obj => obj['pct_of_sales'])
      }

      return []
    }
  },
  components: {
    CardItem,
    CardItemError,
    CardTransition,
    CardItemHeader,
    PerformanceCardHeader
  }
}
</script>

<style scoped>
  .performance-card {
    flex: 1;
    width: 648px;
    height: 358px;
    border-radius: 4px;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px rgb(0 0 0 / 40%);
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    margin-bottom: 16px;
    margin-top: 24px;
    color: #223448;
  }

  .performance-card:first-of-type {
    margin-right: 10px;
  }

  .performance-card:last-of-type {
    margin-left: 10px
  }

  @media only screen and (max-width: 701px) {
    .performance-card {
      flex: auto;
    }

    .performance-card:first-of-type {
      margin-right: 0;
    }

    .performance-card:last-of-type {
      margin-left: 0;
    }
  }

  .performance-card__spinner-icon {
    color: #26c7c8;
  }

  .performance-card__inner--error {
    width: 256px;
    height: 44px;
    margin: 16px auto;
    font-size: 16px;
    line-height: 140%;
    text-align: center;
    color: #778699;
  }

  .performance-card--blurred {
    color: transparent !important;
    text-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    pointer-events: none;
    user-select: none;
  }

  .performance-card__inner {
    margin: 16px;
  }

  .performance-card__container {
    display: flex;
    flex-direction: column;
  }

  hr {
    height: 1px;
    width: 100%;
    border: none;
    background-color: #C1CCD4
  }
</style>
